export type RatingsCountProps = {
  /* 
    @param reviewCount - the review count
  */
  ratingsCount: number;
  /* 
    @param {'default', 'icons'} [type=default] - the type of the ReviewCount component
  */
  type?: 'default' | 'icons';
  /* 
    @param {boolean} [isLinked=false] - indicates if the component is linked and should therfore visible as link
  */
  isLinked?: boolean;
};

/**
 * Displays the Customer Ratings reviews count
 * */
export const RatingsCount = ({
  ratingsCount,
  type = 'default',
  isLinked = false,
  ...props
}: RatingsCountProps) => (
  <span
    className={`${type === 'default' ? 'text-color-text-dark' : 'text-color-text-darktransparent'} text-size-body3 ${isLinked ? 'underline' : 'no-underline'}`}
    {...props}
  >
    ({ratingsCount})
  </span>
);
